import { RowDataMain } from "../../components/MainPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the MainTable factory
 */
class MainRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "api/main/feed/read-range"
        this.accessData = "feeds"
    }

    create(main: any): RowDataMain {
        const rowDataMain: RowDataMain = {
            id: main.id,
            title: main.title,
            video: main.videoSrc,
            thumbnail: main.thumbnailSrc,
            category: main.category,
            show: main.show,
            action: "",
        };
        return rowDataMain;
    }

    generateParams(params: any, extra: any): any {
        params["uid"] = extra.uid
        params["current"] = extra.current
        return params
    }
}

let mainRow: MainRow | null = null;

export default function getMainRow(): MainRow {
    if (mainRow === null)
        mainRow = new MainRow()
    return mainRow
}